module.exports = __webpack_public_path__ + "img/file-import.df07b5b0.svg";